// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2tXwWDEk","areaItem":"_1RNShLva","areaTitle":"_3bqM-Etk","prefectureList":"_2OurBdnu","prefectureItem":"_2e4ZSb9j","prefectureItemText":"_2YedJxc0"};